import { Subscription } from 'rxjs';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { footerObj } from './footer-links-json';
import { DOCUMENT } from '@angular/common';
import { EventsService, StorageService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { NavigationEnd, Router } from '@angular/router';
import { IUser } from 'src/app/shared/models';

@Component({
  selector: 'app-footer',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class FooterMainComponent implements OnInit, OnDestroy {

  isMobile: any;
  footerObj = footerObj;
  subs: Subscription[] = [];
  isUserLoggedIn;
  // removePaddingTop = false;
  // addPb120 = false;
  currentYear = new Date().getFullYear();
  isBrowseFundrPage = false;
  isHome = false;
  email = 'info@ketto.org';
  prEmail = 'pr@ketto.org';
  prContact = '9930088551';
  isHowItWorksPage = false;
  userData: IUser;

  constructor(
    public utilservice: UtilService,
    public variablesService: VariablesService,
    private eventService: EventsService,
    private storageService: StorageService,
    public router: Router,
    @Inject(DOCUMENT) private document: any,
    public vwo: VwoService
  ) {
    this.subs.push(this.router.events
      .subscribe((event) => {
        this.isBrowseFundrPage = variablesService.pageName === 'browse_fundraisers';
        if (event instanceof NavigationEnd) {
          // this.isBrowseFundrPage = this.router.url === '/crowdfunding/fundraisers';
          this.paddingMarginConfigs();
          this.checkLoggedIn();
        }
      })
    );
  }



  ngOnInit() {
    this.paddingMarginConfigs();
    this.checkLoggedIn();
    this.variablesService.userData.subscribe((res: any) => {
      this.userData = res;
    })
  }

  checkLoggedIn() {
    this.utilservice.isLoggedIn$.subscribe(val => {
      this.isUserLoggedIn = val;
    })
  }

  paddingMarginConfigs() {
    this.isMobile = this.utilservice.isMobile();
    // this.checkPadding();

    // remove when footer seo is shown on homepage this is only when footer seo is not shown on homepage 
    if (this.utilservice.isBrowser) {
      this.isHome = window.location.pathname === '/';
      this.isHowItWorksPage = window.location.pathname === '/crowdfunding';
    }
  }

  onLinkClick(item) {
    if (item.type && item.type === 'SAF') {
      const payload = {
        eventName: 'start_a_campaign_initiated',
        event_type: 'campaign',
        page_name: this.variablesService.pageName || 'home',
        referrer_page: this.document.referrer,
        info_1: 'type',
        info_2: 'home_8'
      };
      this.eventService.sendSystemEvent(payload).subscribe(_ => _);
      this.storageService.checkFromSession('sac-initiated', payload);
      if (this.isUserLoggedIn) {
        const sacPuposeSelected = this.storageService.getFromSession('sac-purpose-selected');
        if (!sacPuposeSelected) {
          const payload2 = {
            eventName: 'cause_selection',
            page_name: this.variablesService.pageName,
            info_1: 'type',
            info_2: 'home_8',
            info_4: item.purpose,
            event_type: 'campaign'
          };
          this.eventService.systemEventPush(payload2);
        }
      }
    }
  }

  getCurrentYear() {
    return new Date().getUTCFullYear();
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
